export enum ReusableLayoutChangeType {
  SAVE_AS_NEW = 'saveAsNew',
  UNLINK = 'unlink',
  UPDATE_EXISTING = 'updateExisting',
}
